import { Navigation } from '../Navigation'

const LoggedIn = () => {
    return <Navigation />
}

export default LoggedIn